import { ArticleParagraph1, Image, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { FC } from 'react';

import { TRatingHelp } from './types';

import * as style from './RatingCard.css';

type TRatingCardProps = {
  place: string;
  placeLabel: string;
  description: string;
  icon: string;
  help: TRatingHelp | undefined;
};

export const RatingCard: FC<TRatingCardProps> = ({ place, placeLabel, description, icon, help }) => {
  return (
    <div className={style['card']} data-testid="RatingCard">
      <div className={style['place-wrapper']}>
        <div className={style['place']}>
          <div className={style['place-number']}>{place}</div>
          <ArticleParagraph1>{placeLabel}</ArticleParagraph1>
        </div>
        <div className={style['icon']}>
          <Image alt={`${place} ${description}`} height={45} preloader={false} src={icon} width={45} />
        </div>
      </div>
      <div>
        <UIText2 display="inline">{description}</UIText2>
        {help && (
          <Tooltip header={help.title} theme="white" title={help.text}>
            <div className={style['description-icon']}>
              <div className={style['description-icon--inner']}>
                <IconFunctionalInformationCircle16 />
              </div>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
